export interface SonicOfferData {
  id: string;
  from: string;
  to: string;
  recipient_type: string;
  recipient_account: string;
  type: string;
  other_reasons: string;
  message: string;
  timestamp: number;
  status: string;
  memo: string;
}

export default class SonicOffer implements SonicOfferData {
  id: string;
  from: string;
  to: string;
  recipient_type: string;
  recipient_account: string;
  type: string;
  other_reasons: string;
  message: string;
  timestamp: number;
  status: string;
  memo: string;

  constructor(
    id: string,
    from: string,
    to: string,
    recipient_type: string,
    recipient_account: string,
    type: string,
    other_reasons: string,
    message: string,
    timestamp: number,
    status: string,
    memo: string
  ) {
    this.id = id;
    this.from = from;
    this.to = to;
    this.recipient_type = recipient_type;
    this.recipient_account = recipient_account;
    this.type = type;
    this.other_reasons = other_reasons;
    this.message = message;
    this.timestamp = timestamp;
    this.status = status;
    this.memo = memo;
  }

  static parseFromAPIResponse(item: any) {
    return new SonicOffer(
      item.id,
      item.from,
      item.to,
      item.recipient_type,
      item.recipient_account,
      item.type,
      item.other_reasons,
      item.message,
      item.timestamp,
      item.status,
      item.memo
    );
  }
}
